export const MAX_BULK_UPDATE_SIZE = 5000
